import { getFunctions, httpsCallable } from "firebase/functions";

const functions = getFunctions();

const getConfigCallable = httpsCallable(functions, "getPageGuideConfig");
const getStatusCallable = httpsCallable(functions, "getPageGuidePlatformStatus");
const setPlatformCallable = httpsCallable(functions, "setPageGuidePlatformEnabled");
const upsertConfigCallable = httpsCallable(functions, "upsertPageGuideConfig");
const upsertOverrideCallable = httpsCallable(functions, "upsertPageGuideConfigOverride");

export async function fetchPageGuideConfig(pageId, facilityId) {
  const result = await getConfigCallable({
    pageId,
    ...(facilityId ? { facilityId } : {}),
  });
  return result.data || { platformEnabled: false };
}

export async function fetchPageGuidePlatformStatus() {
  const result = await getStatusCallable({});
  return result.data || { platformEnabled: false };
}

export async function setPageGuidePlatformEnabled(enabled) {
  const result = await setPlatformCallable({ enabled: Boolean(enabled) });
  return result.data;
}

export async function upsertPageGuideConfig(payload) {
  const result = await upsertConfigCallable(payload);
  return result.data;
}

export async function upsertPageGuideConfigOverride(payload) {
  const result = await upsertOverrideCallable(payload);
  return result.data;
}
